<template>
  <div class="technical">
    <div class="technical__box">
      <header class="technical__box__header">
        <div class="technical__box__header__title">
          {{ $t('technical.title') }}
        </div>
      </header>
      <div class="technical__box__container">
        <div class="technical__box__container__no-data" v-if="!currentUseCase">
          {{ $t('noData.noUseCase') }}
        </div>
        <div v-else v-html="currentUseCase.tooltip[$i18n.locale] || currentUseCase.tooltip.default"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Technical',
  computed: {
    ...mapState({
      currentUseCase: state => state.data.currentUseCase,
    }),
  },
  methods: {
    ...mapActions({}),
  },
}
</script>

<style lang="scss" scoped>
.technical {
  width: 100%;

  @media (min-width: $screen-sm) {
    margin-top: $gutter-md;
    height: calc(50% - #{$gutter-md / 2});
  }

  &__box {
    @include box;

    @media (min-width: $screen-sm) {
      height: 100%;
    }

    &__header {
      @include header;

      &__close {
        @include close;
      }

      &__title {
        @include title;
      }
    }

    &__container {
      @include container;

      &__no-data {
        @include noData;
      }
    }
  }
}
</style>
